<template>
  <main-layout
    :selectedMenu="'1'"
    class="developcontainer"
    id="developcontainer"
  >
    <div class="bannerList">
      <transition-group
        name="img"
        tag="ul"
        class="picture list-group"
        style="height: 400px"
      >
        <li
          v-for="(item, i) in bannerList"
          :key="item.id"
          v-if="i === mark"
          @click="gotoLocation(item)"
          @mouseenter="endBan"
          @mouseleave="play"
        >
          <div class="parentbg" style="cursor: pointer">
            <div
              class="background"
              :style="JSON.parse(item.image)[0].key | bgImageUrl"
            ></div>
            <div class="danchu">
              <img
                class="imageSize"
                :src="JSON.parse(item.image)[0].key | imageUrl('')"
                alt=""
              />
            </div>
            <span class="Ad" v-if="item.type == '2'">{{
              $t("video.广告")
            }}</span>
          </div>
          <div
            class="typeTitle"
            v-if="item.type == '1' && item.maTemplate == '1'"
          >
            <div class="maTypeClass">
              <span class="title" :class="'maTypeBgCor' + item.maType">
                {{ getTypeTitle(item.maType) }}
              </span>
            </div>
          </div>
          <div
            class="typeContent"
            v-if="item.type == '1' && item.maTemplate == '1'"
          >
            <div class="contentBox">
              <p class="title">
                {{
                  language === "zh" ? item.title : item.enTitle || item.title
                }}
              </p>
              <p
                class="tags clearfix"
                v-if="
                  item.maType == 1 &&
                  item.otherData &&
                  item.otherData.categoryTags
                "
              >
                <span
                  v-for="(tag, y) in item.otherData.categoryTags"
                  :key="y"
                  class="tag"
                  v-if="y < 5"
                  >{{ tag }}</span
                >
              </p>
              <p class="name" v-if="item.maType == 3">
                  <img
                    class="avatarImg"
                    :src="
                      item.otherData.userAvatar
                        | imageUrl('/static/profile_img_default.png', 40, 40)
                    "
                    alt=""
                  />
                  <span>{{ item.otherData.userNickName }}</span>
              </p>
              <p class="name" v-if="item.maType == 1 && item.otherData && item.otherData.otherUserInfo">
                <template v-for="user, index in item.otherData.otherUserInfo">
                    <span :key="index" style="margin-right:10px">
                      <img
                        class="avatarImg"
                        :src="
                          user.userAvatar
                            | imageUrl('/static/profile_img_default.png', 40, 40)
                        "
                        alt=""
                      />
                      <span>{{ user.userNickName }}</span>
                    </span>
                </template>
              </p>
              <p class="time" v-if="item.maType == 4">
                <span v-if="item.otherData.cityName">{{
                  item.otherData.cityName
                }}</span
                >{{
                  item.otherData.activityStartTime | formatDate("YYYY.MM.DD")
                }}
                -
                {{ item.otherData.activityendTime | formatDate("YYYY.MM.DD") }}
              </p>
              <p class="time" v-if="item.maType == 6">
                {{ item.otherData.liveStartTime | formatDate("YYYY.MM.DD") }}
              </p>
              <p class="subTitle" v-if="item.subTitle">
                {{
                  language === "zh"
                    ? item.subTitle
                    : item.enSubTitle || item.subTitle
                }}
              </p>
            </div>
          </div>
        </li>
      </transition-group>
      <ul class="bannerBtn">
        <li
          v-for="(num, index) in bannerList"
          :key="index"
          :class="[
            'bannerBtn-item',
            { 'bannerBtn-item-active': index == mark },
          ]"
          @mouseenter="stop(index)"
          @mouseleave="play"
          @click="gotoLocation(num)"
        >
          {{ language === "zh" ? num.title : num.enTitle || num.title }}
        </li>
      </ul>
    </div>
    <div class="fiveLocation">
      <filter-table v-bind:cate="tags"></filter-table>
      <div class="homeLocationList clearfix" v-if="locationList.length">
        <div class="location" v-for="(item, i) in locationList" :key="i">
          <img
            class="locationImg"
            @click="gotoLocation(item)"
            :src="JSON.parse(item.image)[0].key | imageUrl('', 416, 312)"
            alt=""
          />
          <div class="advertisement" v-if="item.type == '2'">
            {{ $t("video.广告") }}
          </div>
        </div>
      </div>
    </div>
    <div class="hotClass">
      <div class="tagBox1 clearfix">
        <span
          class="navName"
          :class="{ changeActive: changeType == 1 }"
          @click="changeVideo(1)"
          >{{ $t("video.每日推荐") }}</span
        >
        <span
          class="navName"
          :class="{ changeActive: changeType == 2 }"
          @click="changeVideo(2)"
          >{{ $t("video.新人必看") }}</span
        >
        <span
          class="navName"
          :class="{ changeActive: changeType == 3 }"
          @click="changeVideo(3)"
          >{{ $t("video.最近更新") }}</span
        >
        <span
          class="navName"
          :class="{ changeActive: changeType == 4 }"
          @click="changeVideo(4)"
          >{{ $t("video.我的关注") }}</span
        >
      </div>
      <div class="videoBox" v-if="videoList.length && isShowLogin">
        <span
          class="prePage"
          v-if="this.changeVideoIndex > 1"
          @click="goPrePageVideo()"
        ></span>
        <span
          class="nextPage"
          v-if="this.videoListhasNextPage"
          @click="goNextPageVideo()"
        ></span>
        <changeVideoList :list="videoList" :type="changeType" />
      </div>
      <div v-else-if="isShowLogin" class="noVideoBox">
        <img
          class="videoImg"
          src="/static/newSearch/video_empty@2x.png"
          alt=""
        />
        <p class="title">
          {{ $t("video.暂无关注的创作者发布的作品，快去关注喜欢的创作者吧！") }}
        </p>
        <router-link to="/exploreauth" class="seeButton">{{
          $t("video.发现创作者")
        }}</router-link>
      </div>
      <div v-else class="noVideoBox">
        <img
          class="videoImg"
          src="/static/newSearch/video_empty@2x.png"
          alt=""
        />
        <p class="title">
          {{ $t("video.登录后即可查看关注的作品") }}
        </p>
        <router-link
          :to="`/login?redirecturl=${redirecturl}`"
          class="seeButton"
          >{{ $t("global.立即登录") }}</router-link
        >
      </div>
    </div>
    <div class="hotClass hotClass1">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.热门分类") }}</span>
        <div :class="[language === 'zh' ? 'tags' : 'enTags']">
          <span
            class="tag"
            :class="{ active: categoryIndex == i + 1 }"
            v-for="(item, i) in categoryList"
            :key="i"
            @click="getHotVideo(1, item.id, i)"
            >{{ language === "zh" ? item.name : item.enName }}</span
          >
        </div>
        <div class="more" @click="gotoVideo(1, cateGoryId)">
          <span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="this.cateGoryQuery.pageIndex > 1"
          @click="goPrePage(1)"
        ></span>
        <span
          class="nextPage"
          v-if="this.cateGoryhasNextPage"
          @click="goNextPage(1)"
        ></span>
        <hotTagsVideo :list="categoryVideoList" />
      </div>
    </div>
    <div class="hotClass">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.热门行业") }}</span>
        <div :class="[language === 'zh' ? 'tags' : 'enTags']">
          <span
            class="tag"
            :class="{ active: industryIndex == i + 1 }"
            v-for="(item, i) in industryList"
            :key="i"
            @click="getHotVideo(2, item.id, i)"
            >{{ language === "zh" ? item.name : item.enName }}</span
          >
        </div>
        <div @click="gotoVideo(11, industryId)" class="more">
          <span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="this.industryQuery.pageIndex > 1"
          @click="goPrePage(2)"
        ></span>
        <span
          class="nextPage"
          v-if="this.industryhasNextPage"
          @click="goNextPage(2)"
        ></span>
        <hotTagsVideo :list="industryVideoList" />
      </div>
    </div>
    <div class="hotClass">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.热门应用场景") }}</span>
        <div :class="[language === 'zh' ? 'tags' : 'enTags']">
          <span
            class="tag"
            :class="{ active: sceneIndex == i + 1 }"
            v-for="(item, i) in sceneList"
            :key="i"
            @click="getHotVideo(3, item.id, i)"
            >{{ language === "zh" ? item.name : item.enName }}</span
          >
        </div>
        <div @click="gotoVideo(14, sceneId)" class="more">
          <span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
          />
        </div>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="this.sceneQuery.pageIndex > 1"
          @click="goPrePage(3)"
        ></span>
        <span
          class="nextPage"
          v-if="this.scenehasNextPage"
          @click="goNextPage(3)"
        ></span>
        <hotTagsVideo :list="sceneVideoList" />
      </div>
    </div>
    <div class="homeOneLocation" ref="locationRef" v-if="locationList1.length">
      <img
        class="locationImg"
        @click="gotoLocation(locationList1[0])"
        :src="
          JSON.parse(locationList1[0].image)[0].key | imageUrl('', 2320, 200)
        "
        alt=""
      />
      <div class="advertisement" v-if="locationList1[0].type == '2'">
        {{ $t("video.广告") }}
      </div>
    </div>
    <div class="hotClass" v-if="activityList.length">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.活动推荐") }}</span>
        <router-link to="/activity/all" class="more" target="_blank"
          ><span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
        /></router-link>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="this.activityIndex > 1"
          @click="goPrePageActivity"
        ></span>
        <span
          class="nextPage"
          v-if="this.activityhasNextPage"
          @click="gonextPageActivity"
        ></span>
        <activityLists :list="activityList" />
      </div>
    </div>
    <!-- <div class="hotClass">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.文章") }}</span>
        <router-link to="/article" class="more" target="_blank"
          ><span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
        /></router-link>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="this.articleIndex > 1"
          @click="goPrePageArticle"
        ></span>
        <span
          class="nextPage"
          v-if="this.articlehasNextPage"
          @click="gonextPageArticle"
        ></span>
        <articleLists :list="articleList" />
      </div>
    </div> -->
    <div class="hotClass">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.MANA学院") }}</span>
        <router-link to="/academy/home" class="more" target="_blank"
          ><span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
        /></router-link>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="this.academyIndex > 1"
          @click="goPrePageAcademy"
        ></span>
        <span
          class="nextPage"
          v-if="this.academyhasNextPage"
          @click="gonextPageAcademy"
        ></span>
        <academyLists :list="academyList" />
      </div>
    </div>
    <div class="hotClass">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.入驻高校") }}</span>
        <router-link to="/channel/1" class="more" target="_blank"
          ><span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
        /></router-link>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="this.topicIndex > 1"
          @click="goPrePageTopic"
        ></span>
        <span
          class="nextPage"
          v-if="this.topichasNextPage"
          @click="gonextPageTopic"
        ></span>
        <academyLists :list="topicList" />
      </div>
    </div>
    <div class="hotClass">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.精选创作者") }}</span>
        <router-link to="/exploreauth" class="more" target="_blank"
          ><span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
        /></router-link>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="authorIndex > 1"
          @click="goPrePageAuthor"
        ></span>
        <span
          class="nextPage"
          v-if="authorNextPage"
          @click="gonextPageAuthor"
        ></span>
        <authorLists :list="authorLists" :type="1" />
      </div>
    </div>
    <div class="hotClass">
      <div class="tagBox clearfix">
        <span class="title">{{ $t("video.最新加入创作者") }}</span>
        <router-link to="/exploreauth" class="more" target="_blank"
          ><span>{{ $t("video.更多") }}</span
          ><img
            class="moreIcon"
            src="/static/home/index_view_all_arrow@2x.png"
            alt=""
        /></router-link>
      </div>
      <div class="videoBox">
        <span
          class="prePage"
          v-if="newAuthorIndex > 1"
          @click="goPrePageNewAuthor"
        ></span>
        <span
          class="nextPage"
          v-if="newAuthorNextPage"
          @click="gonextPageNewAuthor"
        ></span>
        <authorLists :list="newAuthorLists" :type="2" />
      </div>
    </div>
    <div class="uploadApp">
      <div class="uploadBox clearfix">
        <div class="uploadLogo">
          <img src="/static/home/bottom_MANA_app_icon@2x.png" alt="" />
        </div>
        <div class="uploadTitle">
          <p class="title1">{{ $t("video.MANA 全球新媒体艺术平台") }}</p>
          <p class="title2">{{ $t("video.全新版客户端发布 使用更流畅") }}</p>
        </div>
        <div class="uploadImg">
          <p class="uploadIOS">
            <img
              :src="
                language === 'zh'
                  ? '/static/home/bottom_dl_app_store_btn@2x.png'
                  : '/static/home/bottom_dl_app_store_btn_en@2x.png'
              "
              alt=""
            />
          </p>
          <p class="uploadAnd">
            <img
              :src="
                language === 'zh'
                  ? '/static/home/bottom_dl_android_btn@2x.png'
                  : '/static/home/bottom_dl_android_btn_en@2x.png'
              "
              alt=""
            />
          </p>
        </div>
        <div class="uploadCode">
          <img src="/static/home/bottom_dl_qrcode@2x.png" alt="" />
        </div>
      </div>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
// import FilterTable from "@/components/FilterTableHome.vue";
import FilterTable from "@/components/FilterTableHome.vue";
import hotTagsVideo from "@/components/home/hotTagsVideo.vue";
import activityLists from "@/components/home/activityLists.vue";
import articleLists from "@/components/home/articleLists.vue";
import academyLists from "@/components/home/academyLists.vue";
import authorLists from "@/components/home/authorLists.vue";
import changeVideoList from "@/components/home/changeVideoList.vue";
export default {
  metaInfo() {
    return {
      title:
        "MANA - " +
        this.$t("global.全球新媒体艺术平台") +
        " - " +
        this.$t("global.艺术/设计/科技 跨界创新"),
    };
  },
  components: {
    MainLayout,
    FilterTable,
    hotTagsVideo,
    activityLists,
    articleLists,
    academyLists,
    authorLists,
    changeVideoList,
  },
  data() {
    return {
      tags: [],
      locationList: [],
      locationList1: [],
      isShowFunc: false,
      bannerList: [],
      mark: 0,
      timer: "",
      categoryList: [],
      industryList: [],
      sceneList: [],
      categoryVideoList: [],
      industryVideoList: [],
      sceneVideoList: [],
      cateGoryhasNextPage: false,
      industryhasNextPage: false,
      scenehasNextPage: false,
      cateGoryId: null,
      industryId: null,
      sceneId: null,
      categoryIndex: 1,
      industryIndex: 1,
      sceneIndex: 1,
      cateGoryQuery: {
        pageIndex: 1,
        pageSize: 4,
      },
      industryQuery: {
        pageIndex: 1,
        pageSize: 4,
      },
      sceneQuery: {
        pageIndex: 1,
        pageSize: 4,
      },
      activityIndex: 1,
      activityList: [],
      activityhasNextPage: false,
      articleIndex: 1,
      articleList: [],
      articlehasNextPage: false,
      academyIndex: 1,
      academyList: [],
      academyhasNextPage: false,
      topicIndex: 1,
      topicList: [],
      topichasNextPage: false,
      authorLists: [],
      authorIndex: 1,
      authorNextPage: false,
      newAuthorLists: [],
      newAuthorIndex: 1,
      newAuthorNextPage: false,
      changeType: 1,
      changeVideoIndex: 1,
      videoList: [],
      videoListhasNextPage: false,
      isShowLogin: true,
    };
  },
  created() {
    this.getBannerList();
    this.$http.get("/api/video/tag/index/tags").then((res) => {
      this.tags = res.data;
    });
    this.getVideoList();
    this.getLocation();
    this.getLocation1();
    this.getVideoTags();
    this.getActivityList();
    // this.getArticleList();
    this.getAcademyList();
    this.getTopicList();
    this.getAuthorList();
    this.getNewAuthorList();
  },

  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.scrollToTop);
    clearInterval(this.timer);
  },
  methods: {
    gotoVideo(type, id) {
      let routeData = this.$router.resolve({
        path: "/explorevideo",
        query: { topGroupId: type, groupId: id },
      });
      window.open(routeData.href, "_blank");
    },
    changeVideo(index) {
      this.changeType = index;
      this.changeVideoIndex = 1;
      this.getVideoList();
    },
    getVideoList() {
      let params = {};
      if (this.changeType == 1) {
        params = {
          pageIndex: this.changeVideoIndex,
          pageSize: 8,
        };
        this.$http.get("/api/video/recommendList", { params }).then((res) => {
          this.videoList = res.data.list;
          this.videoListhasNextPage = res.data.hasNextPage;
          this.isShowLogin = true;
        });
      }
      if (this.changeType == 2) {
        params = {
          pageIndex: this.changeVideoIndex,
          pageSize: 8,
          type: 3,
        };
        this.$http.get("/api/stat/getRankingList", { params }).then((res) => {
          this.videoList = res.data.list;
          this.videoListhasNextPage = res.data.hasNextPage;
          this.isShowLogin = true;
        });
      }
      if (this.changeType == 3) {
        params = {
          pageIndex: this.changeVideoIndex,
          pageSize: 8,
          orderByType: 1,
        };
        this.$http.get("/api/video/findVideoList", { params }).then((res) => {
          this.videoList = res.data.list;
          this.videoListhasNextPage = res.data.hasNextPage;
          this.isShowLogin = true;
        });
      }
      if (this.changeType == 4) {
        if (!localStorage.getItem("auth_token")) {
          this.isShowLogin = false;
          return;
        }
        params = {
          pageIndex: this.changeVideoIndex,
          pageSize: 8,
        };
        this.$http.get("/api/video/careList", { params }).then((res) => {
          this.videoList = res.data.list;
          this.videoListhasNextPage = res.data.hasNextPage;
          this.isShowLogin = true;
        });
      }
    },
    goPrePageVideo() {
      this.changeVideoIndex--;
      this.getVideoList();
    },
    goNextPageVideo() {
      this.changeVideoIndex++;
      this.getVideoList();
    },
    getVideoTags() {
      this.$http.get("/api/index/video/hotTags").then((res) => {
        if (res.code === "OK") {
          this.categoryList = res.data.category;
          this.industryList = res.data.industry;
          this.sceneList = res.data.scene;
          if (this.categoryList[0].id) {
            this.getHotVideo(1, this.categoryList[0].id);
          }
          if (this.industryList[0].id) {
            this.getHotVideo(2, this.industryList[0].id);
          }
          if (this.sceneList[0].id) {
            this.getHotVideo(3, this.sceneList[0].id);
          }
        }
      });
    },
    getHotVideo(type, id, index) {
      let params = {};
      if (type == 1) {
        if (index + 1) {
          this.categoryIndex = index + 1;
          this.cateGoryQuery.pageIndex = 1;
        }
        this.cateGoryId = id;
        params = {
          tagId: this.cateGoryId,
          pageIndex: this.cateGoryQuery.pageIndex,
          pageSize: this.cateGoryQuery.pageSize,
        };
      }
      if (type == 2) {
        if (index + 1) {
          this.industryIndex = index + 1;
          this.industryQuery.pageIndex = 1;
        }
        this.industryId = id;
        params = {
          tagId: this.industryId,
          pageIndex: this.industryQuery.pageIndex,
          pageSize: this.industryQuery.pageSize,
        };
      }
      if (type == 3) {
        if (index + 1) {
          this.sceneIndex = index + 1;
          this.sceneQuery.pageIndex = 1;
        }
        this.sceneId = id;
        params = {
          tagId: this.sceneId,
          pageIndex: this.sceneQuery.pageIndex,
          pageSize: this.sceneQuery.pageSize,
        };
      }
      this.$http
        .get("/api/index/video/hotVideo/" + id, { params })
        .then((res) => {
          if (res.code === "OK") {
            if (type == 1) {
              this.categoryVideoList = res.data.list;
              this.cateGoryhasNextPage = res.data.hasNextPage;
              this.$forceUpdate();
            }
            if (type == 2) {
              this.industryVideoList = res.data.list;
              this.industryhasNextPage = res.data.hasNextPage;
              this.$forceUpdate();
            }
            if (type == 3) {
              this.sceneVideoList = res.data.list;
              this.scenehasNextPage = res.data.hasNextPage;
              this.$forceUpdate();
            }
          }
        });
    },
    goPrePage(type) {
      let id = null;
      if (type == 1) {
        this.cateGoryQuery.pageIndex--;
        id = this.cateGoryId;
      }
      if (type == 2) {
        this.industryQuery.pageIndex--;
        id = this.industryId;
      }
      if (type == 3) {
        this.sceneQuery.pageIndex--;
        id = this.sceneId;
      }
      this.getHotVideo(type, id);
    },
    goNextPage(type) {
      let id = null;
      if (type == 1) {
        this.cateGoryQuery.pageIndex++;
        id = this.cateGoryId;
      }
      if (type == 2) {
        this.industryQuery.pageIndex++;
        id = this.industryId;
      }
      if (type == 3) {
        this.sceneQuery.pageIndex++;
        id = this.sceneId;
      }
      this.getHotVideo(type, id);
    },
    play() {
      this.timer = setInterval(() => {
        if (this.mark < this.bannerList.length - 1) {
          this.mark++;
        } else {
          this.mark = 0;
        }
      }, 5000);
    },
    stop(e) {
      this.mark = e;
      clearInterval(this.timer);
      this.timer = null;
    },
    endBan() {
      clearInterval(this.timer);
      this.timer = null;
    },
    scrollToTop() {
      if (this.$refs.locationRef) {
        var scrollTop = this.$refs.locationRef.getBoundingClientRect().top;
        var bodyHeight = document.body.offsetHeight;
        if (scrollTop - bodyHeight <= 0) {
          this.locationShow1(this.locationList1[0]);
          this.isShowFunc = true;
        }
      }
    },
    getBannerList() {
      this.$http.get("/api/operations/list/1").then((res) => {
        if (res.code === "OK") {
          this.bannerList = res.data;
          this.play();
          this.locationShow(this.bannerList[0]);
        }
      });
    },
    getLocation() {
      this.$http.get("/api/operations/list/11").then((res) => {
        if (res.code === "OK") {
          this.locationList = res.data;
          let forms = [];
          if (this.locationList.length) {
            for (let i = 0; i < this.locationList.length; i++) {
              forms.push({
                locationId: this.locationList[i].locationId,
                sort: this.locationList[i].sort,
                configId: this.locationList[i].id,
              });
              // this.locationShow(this.locationList[i])
            }
            this.getLocationShows(forms);
          }
        }
      });
    },
    getLocationShows(forms) {
      let params = {
        forms: JSON.stringify(forms),
      };
      this.$http.post("/api/operations/show/batch", params).then((res) => {});
    },
    getLocation1() {
      this.$http.get("/api/operations/list/12").then((res) => {
        if (res.code === "OK") {
          this.locationList1 = res.data;
        }
      });
    },
    locationClick(item) {
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/click", params).then((res) => {
        //运营位点击
      });
    },
    locationShow(item) {
      if (item.isFunc) {
        return;
      }
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/show", params).then((res) => {
        //运营位展示
        item.isFunc = true;
      });
    },
    locationShow1(item) {
      if (this.isShowFunc) {
        return;
      }
      let params = {
        locationId: item.locationId,
        sort: item.sort,
        configId: item.id,
      };
      this.$http.post("/api/operations/show", params).then((res) => {
        //运营位展示
      });
    },
    gotoLocation(item) {
      this.locationClick(item);
      this.openLocatione(item);
    },
    getTypeTitle(maType) {
      if (maType == "1") {
        return "# " + this.$t("video.精选作品");
      }
      if (maType == "3") {
        return "# " + this.$t("video.精选文章");
      }
      if (maType == "4") {
        return "# " + this.$t("video.精选活动");
      }
      if (maType == "5") {
        return "# " + this.$t("video.精选频道");
      }
      if (maType == "6") {
        return "# " + this.$t("video.直播");
      }
    },
    getActivityList() {
      let params = {
        pageIndex: this.activityIndex,
        pageSize: 5,
      };
      this.$http
        .get("/api/index/activity/indexList", { params })
        .then((res) => {
          this.activityList = res.data.list;
          this.activityhasNextPage = res.data.hasNextPage;
        });
    },
    goPrePageActivity() {
      this.activityIndex--;
      this.getActivityList();
    },
    gonextPageActivity() {
      this.activityIndex++;
      this.getActivityList();
    },
    getArticleList() {
      let params = {
        pageIndex: this.articleIndex,
        pageSize: 4,
      };
      this.$http.get("/api/index/article/indexList", { params }).then((res) => {
        this.articleList = res.data.list;
        this.articlehasNextPage = res.data.hasNextPage;
      });
    },
    goPrePageArticle() {
      this.articleIndex--;
      this.getArticleList();
    },
    gonextPageArticle() {
      this.articleIndex++;
      this.getArticleList();
    },
    getAcademyList() {
      let params = {
        pageIndex: this.academyIndex,
        pageSize: 4,
      };
      this.$http.get("/api/index/academy/indexList", { params }).then((res) => {
        this.academyList = res.data.list;
        this.academyhasNextPage = res.data.hasNextPage;
      });
    },
    goPrePageAcademy() {
      this.academyIndex--;
      this.getAcademyList();
    },
    gonextPageAcademy() {
      this.academyIndex++;
      this.getAcademyList();
    },
    getTopicList() {
      let params = {
        pageIndex: this.topicIndex,
        pageSize: 4,
      };
      this.$http.get("/api/index/topic/indexList", { params }).then((res) => {
        this.topicList = res.data.list;
        this.topichasNextPage = res.data.hasNextPage;
      });
    },
    goPrePageTopic() {
      this.topicIndex--;
      this.getTopicList();
    },
    gonextPageTopic() {
      this.topicIndex++;
      this.getTopicList();
    },
    getAuthorList() {
      let params = {
        pageIndex: this.authorIndex,
        pageSize: 10,
      };
      this.$http
        .get("/api/index/author/indexList/page", { params })
        .then((res) => {
          this.authorLists = res.data.list;
          this.authorNextPage = res.data.hasNextPage;
        });
    },
    goPrePageAuthor() {
      this.authorIndex--;
      this.getAuthorList();
    },
    gonextPageAuthor() {
      this.authorIndex++;
      this.getAuthorList();
    },
    getNewAuthorList() {
      let params = {
        pageIndex: this.newAuthorIndex,
        pageSize: 5,
      };
      this.$http
        .get("/api/index/author/new/indexList/page", { params })
        .then((res) => {
          this.newAuthorLists = res.data.list;
          this.newAuthorNextPage = res.data.hasNextPage;
        });
    },
    goPrePageNewAuthor() {
      this.newAuthorIndex--;
      this.getNewAuthorList();
    },
    gonextPageNewAuthor() {
      this.newAuthorIndex++;
      this.getNewAuthorList();
    },
  },

  computed: {
    language() {
      return this.$language();
    },
    redirecturl() {
      return window.location.href.split("?")[0];
    },
  },
  watch: {
    mark(val) {
      this.locationShow(this.bannerList[val]);
    },
  },
};
</script>
<style lang="stylus">
.img-enter-active, .img-leave-active {
  transition: all 1s;
}

.img-enter, .img-leave-to {
  opacity: 0;
}

.img-enter-to, .img-leave {
  opacity: 1;
}
</style>
<style lang="stylus" scoped>
.fiveLocation {
  width: 1110px;
  margin: 28px auto 0;

  @media screen and (max-width: 1280px) {
    // margin-left: 85px;
  }

  .homeLocationList {
    margin-top: 28px;

    .location {
      width: 198px;
      height: 149px;
      margin-right: 30px;
      position: relative;
      cursor: pointer;
      float: left;

      &:last-child {
        margin-right: 0;
      }

      .locationImg {
        width: 100%;
        height: 100%;
        display: inline-block;
      }

      .advertisement {
        position: absolute;
        left: 0;
        bottom: 0;
        padding: 0 4px;
        height: 16px;
        background: rgba(51, 51, 51, 0.4);
        border-radius: 0px 6px 0px 0px;
        line-height: 16px;
        text-align: center;
        font-size: 10px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }
}

.hotClass {
  width: 1110px;
  margin: 70px auto 0;

  @media screen and (max-width: 1280px) {
    // margin-left: 85px;
  }

  .tagBox {
    margin-bottom: 27px;
    height: 28px;
    line-height: 28px;
    padding: 4px 0;

    .title {
      font-size: 24px;
      font-weight: 600;
      color: #0A0A0A;
      float: left;
      margin-right: 24px;
    }

    .tags {
      float: left;
      display: flex;
      flex-direction: row;
      flex-wrap: no-wrap;
      width: 854px;

      .tag {
        padding: 0 10px;
        height: 28px;
        background: #F5F5F5;
        border-radius: 17px;
        line-height: 28px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 16px;
        min-width: 66px;
        text-align: center;
        cursor: pointer;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .active {
        font-weight: 600;
        color: #FFFFFF;
        background: #2026CC;
      }
    }

    .enTags {
      float: left;
      width: 854px;
      overflow: hidden;
      height: 28px;

      .tag {
        display: inline-block;
        padding: 0 10px;
        height: 28px;
        background: #F5F5F5;
        border-radius: 17px;
        line-height: 28px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        margin-right: 16px;
        text-align: center;
        cursor: pointer;
      }

      .active {
        font-weight: 600;
        color: #FFFFFF;
        background: #2026CC;
      }
    }

    .more {
      float: right;
      cursor: pointer;

      span {
        font-size: 14px;
        font-weight: 400;
        color: #0A0A0A;
        display: inline-block;
      }

      &:hover span {
        border-bottom: 1px solid rgba(10, 10, 10, 1);
      }

      .moreIcon {
        width: 13px;
        height: 13px;
        margin-bottom: 2px;
      }
    }
  }

  .tagBox1 {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    margin-bottom: 30px;

    .navName {
      font-size: 24px;
      font-weight: 400;
      color: #999999;
      float: left;
      height: 48px;
      margin-right: 60px;
      cursor: pointer;

      &:hover {
        color: #0A0A0A;
      }
    }

    .changeActive {
      font-weight: 600;
      color: #0A0A0A;
      border-bottom: 2px solid rgba(10, 10, 10, 1);
    }
  }

  .videoBox {
    width: 1110px;
    position: relative;

    .prePage {
      position: absolute;
      width: 44px;
      height: 44px;
      left: -64px;
      top: 50%;
      transform: translateY(-50%);
      background: url('/static/home/index_prev_arrow@2x.png') no-repeat;
      background-size: 100%;
      cursor: pointer;

      &:hover {
        background: url('/static/home/index_prev_arrow_hover@2x.png') no-repeat;
        background-size: 100%;
      }
    }

    .nextPage {
      position: absolute;
      width: 44px;
      height: 44px;
      right: -64px;
      top: 50%;
      transform: translateY(-50%);
      background: url('/static/home/index_next_arrow@2x.png') no-repeat;
      background-size: 100%;
      cursor: pointer;

      &:hover {
        background: url('/static/home/index_next_arrow_hover@2x.png') no-repeat;
        background-size: 100%;
      }
    }
  }

  .noVideoBox {
    width: 1110px;
    height: 426px;
    text-align: center;
    padding-top: 110px;

    .videoImg {
      width: 88px;
      height: 88px;
    }

    .title {
      height: 21px;
      font-size: 15px;
      font-weight: 400;
      color: #B8B8B8;
      line-height: 21px;
      margin: 30px 0 40px 0;
    }

    .seeButton {
      display: block;
      width: 170px;
      height: 40px;
      background: #2026CC;
      line-height: 40px;
      font-size: 16px;
      font-weight: 400;
      color: #FFFFFF;
      margin: 0 auto;

      &:hover {
        background: #1c21b0;
      }
    }
  }
}

.hotClass1 {
  margin: 46px auto 0;

  @media screen and (max-width: 1280px) {
    // margin-left: 85px;
  }
}

.homeOneLocation {
  width: 1110px;
  height: 100px;
  position: relative;
  cursor: pointer;
  margin: 80px auto 60px;

  @media screen and (max-width: 1280px) {
    // margin-left: 85px;
  }

  .locationImg {
    width: 100%;
    height: 100%;
    display: inline-block;
  }

  .advertisement {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 4px;
    height: 16px;
    background: rgba(51, 51, 51, 0.4);
    border-radius: 0px 6px 0px 0px;
    line-height: 16px;
    text-align: center;
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
  }
}

.bannerContainer {
  width: 280px;
  margin: 0 auto;
  height: 400px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 26%, rgba(0, 0, 0, 0.6) 79%, rgba(0, 0, 0, 0) 100%);

  .leftBar {
    display: none;
    float: left;
    width: 400px;
    height: 398px;

    img {
      height: 100%;
    }
  }

  .rightBar {
    float: right;
    height: 400px;
    width: 280px;
    padding-top: 38px;
    box-sizing: border-box;

    ul {
      li {
        height: 36px;
        font-size: 13px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        padding: 0 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        cursor: pointer;
      }

      li.activeli {
        height: 56px;
        line-height: 56px;
        background: rgba(32, 38, 204, 0.45);
        padding: 0 16px;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 16px;
      }
    }
  }
}

.bannerList {
  position: relative;
  min-width: 1280px;

  .bannerBtn {
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 26%, rgba(0, 0, 0, 0.6) 79%, rgba(0, 0, 0, 0) 100%);
    position: absolute;
    left: calc(100% - ((100% - 1160px) / 2) - 140px);
    top: 0;
    width: 280px;
    height: 400px;
    padding-top: 38px;
    box-sizing: border-box;

    li.bannerBtn-item {
      height: 36px;
      font-size: 13px;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      padding: 0 16px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      cursor: pointer;
    }

    li.bannerBtn-item-active {
      height: 56px;
      line-height: 56px;
      background: rgba(32, 38, 204, 0.45);
      padding: 0 16px;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 16px;
    }
  }
}

.typeContent {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 240px;
  cursor: pointer;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%);

  .contentBox {
    width: 1110px;
    // width: 1055px;
    position: absolute;
    left: 50%;
    bottom: 48px;
    transform: translateX(-50%);

    // padding-left: 55px;
    .title {
      width: 730px;
      min-height: 45px;
      font-size: 30px;
      font-weight: 600;
      color: #FFFFFF;
      line-height: 45px;
      margin-top: 72px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
      text-shadow: 0px 2px 6px rgba(0, 0, 0, 0.5);
    }

    .tags {
      width: 730px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 12px;

      span.tag {
        float: left;
        padding: 0 12px;
        height: 22px;
        line-height: 22px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 11px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
        margin-right: 10px;
      }
    }

    .name {
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      width: 730px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 12px;

      .avatarImg {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 6px;
      }
    }

    .time {
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 12px;

      span {
        margin-right: 20px;
      }
    }

    .subTitle {
      width: 730px;
      height: 18px;
      font-size: 12px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 18px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      margin-top: 12px;
    }
  }
}

.typeTitle {
  position: absolute;
  top: 28px;
  left: 0;
  width: 100%;

  .maTypeClass {
    width: 1110px;
    // width: 1055px;
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);

    // padding-left: 55px;
    .title {
      display: inline-block;
      height: 28px;
      line-height: 28px;
      padding: 0 10px;
      font-size: 14px;
      font-weight: 600;
      color: #FFFFFF;
      border-radius: 2px;
    }

    .maTypeBgCor1 {
      background: rgba(54, 100, 237, 0.85);
    }

    .maTypeBgCor3 {
      background: rgba(255, 200, 16, 0.85);
    }

    .maTypeBgCor6 {
      background: rgba(44, 211, 203, 0.85);
    }

    .maTypeBgCor4 {
      background: rgba(252, 98, 64, 0.85);
    }

    .maTypeBgCor5 {
      background: rgba(123, 32, 204, 0.85);
    }
  }
}

.parentbg {
  width: 100%;
  height: 400px;
  overflow: hidden;
  position: absolute;

  .background {
    position: absolute;
    // z-index: -1;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 400px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100%;
    -webkit-filter: blur(10px);
    -moz-filter: blur(10px);
    -ms-filter: blur(10px);
    -o-filter: blur(10px);
    filter: blur(10px);
    -webkit-transform: scale(1.05);
    -moz-transform: scale(1.05);
    -ms-transform: scale(1.05);
    -o-transform: scale(1.05);
    transform: scale(1.05);
  }

  .Ad {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0 4px;
    height: 16px;
    text-align: center;
    background: rgba(51, 51, 51, 0.4);
    border-radius: 0px 6px 0px 0px;
    line-height: 16px;
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.8);
  }

  .danchu {
    .imageSize {
      height: 400px;
      margin-left: 50%;
      transform: translate(-50%);
      display: inline-block;
      text-align: center;
    }
  }
}

.uploadApp {
  width: 100%;
  height: 150px;
  background: linear-gradient(180deg, rgba(54, 100, 237, 0.85), rgba(32, 38, 204, 0.85));
  margin-top: 50px;
  min-width: 1280px;

  .uploadBox {
    width: 1110px;
    margin: 0 auto;

    .uploadLogo {
      float: left;
      width: 105px;
      height: 105px;
      margin-top: 23px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .uploadTitle {
      float: left;
      width: 585px;
      margin: 42px 36px 0;

      .title1 {
        font-size: 24px;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 32px;
        margin-bottom: 8px;
      }

      .title2 {
        font-size: 18px;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 25px;
      }
    }

    .uploadImg {
      float: left;
      margin-top: 19px;

      .uploadIOS {
        width: 160px;
        height: 52px;
        margin-bottom: 8px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .uploadAnd {
        width: 160px;
        height: 52px;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .uploadCode {
      float: left;
      margin: 15px 0 0 69px;
      width: 113px;
      height: 113px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .bannerList {
    .bannerBtn {
      left: calc(100% - ((100% - 1160px) / 2) - 150px);
      width: 210px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue